import { TreeElement, TreeElementParent } from './ContentSuggestionValue';
import TreeElementLabel from './TreeElementLabel';

type Props = Readonly<{
  treeElement: TreeElement;
  treeElementParent: TreeElementParent;
}>;

export default function ContentSuggestionLabel({
  treeElement,
  treeElementParent,
}: Props): JSX.Element {
  const showAbbreviation =
    treeElementParent.abbreviation &&
    treeElement.name !== treeElementParent.abbreviation;

  return (
    <div className='d-flex'>
      <TreeElementLabel
        icon={treeElement.icon}
        iconColorHexCode={treeElement.iconColorHexCode}
        name={treeElement.name}
      />
      {showAbbreviation && (
        <>
          <span className='mx-1'>|</span>
          <TreeElementLabel
            icon={treeElementParent.icon}
            iconColorHexCode={treeElementParent.iconColorHexCode}
            name={treeElementParent.abbreviation}
          />
        </>
      )}
    </div>
  );
}
